import { useQuery } from "@tanstack/react-query";
import { OrderSummaryFragment } from "./fragments/order-summary";
import { gqlReq } from "~/libs/gql";
import {
	GetOperationalOrdersDocument,
	GetOperationalOrdersQuery,
} from "~/types/__generated/gql/graphql";
import { useVenueId } from "~/store";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		query GetOperationalOrders {
			getOperationalOrders {
				...OrderSummaryFragment
			}
		}
		${OrderSummaryFragment}
	`
);

export const getOperationalOrdersQueryKey = () => ["getOperationalOrders"];

export const getOperationalOrdersQueryFn = (signal?: AbortSignal) =>
	gqlReq({
		document: GetOperationalOrdersDocument,
		signal,
	});

export const useGetOperationalOrders = () => {
	const venueId = useVenueId();

	return useQuery({
		enabled: !!venueId,
		queryKey: getOperationalOrdersQueryKey(),
		queryFn: ({ signal }) => getOperationalOrdersQueryFn(signal),
	});
};

export const usePlacedOrders = () => {
	const { data = [], ...rest } = useGetOperationalOrders();

	return {
		...rest,
		data: data.filter((order) => order.status === "placed"),
	};
};

export const usePreparingOrders = () => {
	const { data = [], ...rest } = useGetOperationalOrders();

	return {
		...rest,
		data: data.filter((order) => order.status === "preparing"),
	};
};

export const useProcessedOrdrs = () => {
	const { data = [], ...rest } = useGetOperationalOrders();

	return {
		...rest,
		data: data.filter((order) => order.status === "processed"),
	};
};

export const getOrdersCache = () => {
	return (
		queryClient.getQueryData<GqlResultOf<GetOperationalOrdersQuery>>(
			getOperationalOrdersQueryKey(),
			{ exact: true },
		) ?? []
	);
};
